import { render } from "./index.vue?vue&type=template&id=0fe3cbdc&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0fe3cbdc&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe3cbdc"]])

export default __exports__